export default __webpack_public_path__ + "static/media/gallery_06.2cc393a3.jpg";